import { Chip } from '@mui/material'
import { CheckCircle, Clock, XOctagon } from 'react-feather'
import palette from '../../../../theme/palette'
import { t } from 'i18next'

type StatusChipProps = {
	status: 'IN_PROGRESS' | 'COMPLETED' | 'WAITING' | 'LOADING'
}

export const StatusChip = ({ status }: StatusChipProps) => {
	switch (status) {
		case 'IN_PROGRESS':
			return (
				<Chip
					icon={<Clock color={palette.brand.main} />}
					label={t('campaign_status.in_progress')}
					sx={{ '.MuiChip-label': { ml: '4px', fontWeight: 'bold', color: palette.brand.main } }}
				/>
			)
		case 'COMPLETED':
			return (
				<Chip
					icon={<CheckCircle color={palette.colors.completed} />}
					label={t('campaign_status.completed')}
					sx={{ '.MuiChip-label': { ml: '4px', fontWeight: 'bold', color: palette.colors.completed } }}
				/>
			)
		case 'WAITING':
			return (
				<Chip
					icon={<XOctagon color={palette.colors.warn} />}
					label={t('campaign_status.waiting')}
					sx={{
						backgroundColor: palette.colors.backgroundWarn,
						'.MuiChip-label': { ml: '4px', fontWeight: 'bold', color: palette.colors.warn },
					}}
				/>
			)
		case 'LOADING':
			return (
				<Chip
					icon={<Clock color={palette.text.white} />}
					label={t('campaign_status.loading')}
					sx={{
						backgroundColor: palette.colors.grey,
						'.MuiChip-label': { ml: '4px', fontWeight: 'bold', color: palette.text.white },
					}}
				/>
			)
	}
}
